var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiStarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7144 3.83644C13.4482 3.86906 13.2305 4.0829 13.2305 4.34991C13.2305 4.61692 13.4482 4.82954 13.7144 4.86214C15.4661 5.08081 16.8539 6.46653 17.0728 8.21597C17.1055 8.48176 17.3184 8.69922 17.5857 8.69922C17.8531 8.69922 18.0672 8.48176 18.0999 8.21597C18.3177 6.46662 19.7065 5.0808 21.4583 4.86214C21.7233 4.82952 21.9411 4.61689 21.9411 4.34991C21.9411 4.08293 21.7233 3.86907 21.4583 3.83644C19.7066 3.61898 18.3176 2.23205 18.0999 0.48261C18.0673 0.218031 17.8531 0.000566483 17.5857 0.000566483C17.3184 0.000566483 17.1055 0.218027 17.0728 0.48261C16.8538 2.23196 15.4662 3.61902 13.7144 3.83644Z",
    fill: "url(#paint0_linear_1771_29727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.644804 11.5708C0.290348 11.5997 0 11.8849 0 12.2413C0 12.5977 0.290348 12.8828 0.644804 12.9118C4.40709 13.2223 7.40627 16.2174 7.71597 19.9733C7.74501 20.3284 8.03171 20.6172 8.38741 20.6172C8.74428 20.6172 9.0298 20.3284 9.06005 19.9733C9.36976 16.2171 12.3689 13.2223 16.13 12.9118C16.4856 12.8828 16.776 12.5977 16.776 12.2413C16.776 11.8849 16.4856 11.5998 16.13 11.5708C12.3686 11.2603 9.36976 8.26517 9.06005 4.50927C9.02981 4.15409 8.74431 3.86535 8.38741 3.86535C8.03174 3.86535 7.74502 4.15409 7.71597 4.50927C7.40627 8.26548 4.40709 11.2602 0.644804 11.5708Z",
    fill: "url(#paint1_linear_1771_29727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1771_29727",
    x1: 14.507,
    y1: 4.34989,
    x2: 19.9097,
    y2: 4.18666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4001D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1771_29727",
    x1: 2.45855,
    y1: 12.2413,
    x2: 12.8637,
    y2: 11.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4001D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStarIcon);
export default __webpack_public_path__ + "static/media/AiStar_Icon.9dc308ff9debf1346b4ccff1538201fd.svg";
export { ForwardRef as ReactComponent };